import { render, staticRenderFns } from "./ResizeImageCanvas.vue?vue&type=template&id=4017c413&scoped=true&"
import script from "./ResizeImageCanvas.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ResizeImageCanvas.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ResizeImageCanvas.vue?vue&type=style&index=0&id=4017c413&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4017c413",
  null
  
)

export default component.exports